import { componentAccordion, componentModal, componentSlider } from "./components";
import videojs from 'video.js';

componentAccordion();
componentModal();
componentSlider();